module.exports = __webpack_public_path__ + "static/media/sub-table-sample-1-preview.a90319d3.png";